var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import { useEffect, useState, useMemo } from 'react';
import api from '@utils/axios';
import { translate } from '@utils/i18n';
import { namespace } from './constants';
import { externalFormPath, externalFormsPath } from '../../../../routes';
import toast from 'react-hot-toast';
function useExternalForms({ searchText, frequencies }) {
    const [forms, setForms] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingEdit, setLoadingEdit] = useState(false);
    const sortByName = (forms) => [...forms].sort((a, b) => a.displayName.localeCompare(b.displayName, undefined, { sensitivity: 'base' }));
    const getExternalForms = () => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        try {
            const res = yield api.get(externalFormsPath({ format: 'json' }));
            const fetchedForms = res.data.externalForms;
            setForms(sortByName(fetchedForms));
        }
        finally {
            setLoading(false);
        }
    });
    const addExternalForm = (form) => {
        setForms((prev) => sortByName([...prev, form]));
    };
    const updateExternalForm = (_a) => __awaiter(this, [_a], void 0, function* ({ id, displayName, active, hasAllFrequencies, frequencyIds, visitType, autoInclude, excludeFromReports, pdfFileName, territoryIds }) {
        try {
            setLoadingEdit(true);
            yield api.patch(`${externalFormPath(id)}.json`, {
                external_form: {
                    has_all_frequencies: hasAllFrequencies,
                    frequency_ids: frequencyIds,
                    display_name: displayName,
                    active,
                    visit_type: visitType,
                    auto_include: autoInclude,
                    exclude_from_reports: excludeFromReports,
                    pdf_file_name: pdfFileName,
                    territory_ids: territoryIds
                }
            });
            const frequencyString = hasAllFrequencies
                ? translate('all', { namespace: 'generic' })
                : frequencyIds.map((fid) => { var _a; return (_a = frequencies.find((freq) => freq.value === fid)) === null || _a === void 0 ? void 0 : _a.label; }).join(', ');
            setForms((prev) => sortByName(prev.map((f) => f.id === id
                ? Object.assign(Object.assign({}, f), { hasAllFrequencies,
                    frequencyIds, frequencyString: frequencyString || '--', displayName,
                    active,
                    visitType,
                    autoInclude,
                    excludeFromReports,
                    territoryIds }) : f)));
            toast.success(translate('update_success', { namespace }));
            return true;
        }
        catch (e) {
            toast.error(translate('update_failure', { namespace }));
            return false;
        }
        finally {
            setLoadingEdit(false);
        }
    });
    useEffect(() => {
        void getExternalForms();
    }, []);
    const filteredForms = useMemo(() => {
        if (!searchText.trim())
            return forms;
        const lowerSearch = searchText.toLowerCase();
        return forms.filter(({ displayName, frequencyString, template }) => [displayName, frequencyString, template === null || template === void 0 ? void 0 : template.country, template === null || template === void 0 ? void 0 : template.state, template === null || template === void 0 ? void 0 : template.city].some((field) => field === null || field === void 0 ? void 0 : field.toLowerCase().includes(lowerSearch)));
    }, [searchText, forms]);
    return {
        forms: filteredForms,
        addExternalForm,
        loading,
        updateExternalForm,
        loadingEdit
    };
}
export default useExternalForms;
